import React from "react";
import styled from "styled-components";
import profile from "../images/header.jpg";
import { useTranslation } from "react-i18next";

const Wrap = styled.div`
display: flex;
background-color: #f3f2eaff;
flex-direction: column;
  @media (min-width: 1024px) {
    width: 100vw;
    position: relative;
  }
`;  

const ImageWrapper = styled.div`
  height: 50vh;
  img {
    height: 100%;
    width: -webkit-fill-available;
    object-fit: cover;
    -webkit-transform: scaleX(-1);
    -moz-transform: scaleX(-1);
    -o-transform: scaleX(-1);
    transform: scalex(-1);\
    -webkit-filter:   contrast(85%) grayscale(0%) hue-rotate(20deg) invert(0%) opacity(80%) saturate(100%) sepia(20%);
    filter:   contrast(100%) grayscale(0%) hue-rotate(20deg) invert(0%) opacity(80%) saturate(100%) sepia(20%);

    @media (min-width: 1024px) {
      object-position: 0% 35%;
    }
  }

  @media (min-width: 1024px) {
    height: 90vh;
    width: 80vw;
    margin-left: auto;
  }
`;

const TextContainer = styled.div `
  display: flex;
  flex-direction: column;
  font-family: Lato;
  line-height: 1.4;
  font-size: 18px;
  padding: 30px 15px 85px;
  text-align: left;
  z-index: 1;
  height: 100%;

  h2 {
    color: #342020ff;
    margin-bottom: 25px;
  }

  @media (min-width: 1024px) {
      padding: 70px 60px 70px 60px;
      position: absolute;
      height: fit-content;
      margin: 100px 0 30px 90px;
      background: #f9f9f9;
      width: 22vw;
  }
`;

const Text = styled.div`
  color: #3D3D3D;
  font-size: 17px;
  p {
    margin-bottom: 20px;
  }


`;

const About = () => {
  const { t, i18n } = useTranslation();
  
    return (
      <Wrap id="about">
        <ImageWrapper data-scroll data-scroll-speed="1">
          <img src={profile} alt='Aurélie' />
        </ImageWrapper>
        <TextContainer>
          <h2>{t("meetAurelie")}</h2>
          <Text>
            <p>{t("aboutParaph1")}</p>
            <p>{t("aboutParaph2")}</p>
            <p>{t("aboutParaph3")}</p>
          
          </Text>
        </TextContainer> 
      </Wrap>
    );
};

export default About;